// NEW_FILE_JUSTIFIED: Extracted page wrapper components from App.tsx to fix no-giant-component diagnostic
import { useNavigate, useParams, Navigate } from 'react-router-dom';
import { AppLayoutMemo } from '@/components/layout';
import { LeadsPage } from '@/pages/LeadsPage';
import { LeadsBoardPage } from '@/pages/LeadsBoardPage';
import { PostWriterPage } from '@/pages/PostWriterPage';
import { PostsSchedulePage } from '@/pages/PostsSchedulePage';
import { BusinessSettingsPage } from '@/pages/BusinessSettingsPage';
import { AiModelsSettingsPage } from '@/pages/AiModelsSettingsPage';
import { SettingsPromptsPageMemo } from '@/pages/SettingsPromptsPage';
import { PostGenerationMultiAIPage } from '@/pages/PostGenerationMultiAIPage';
import { PostEditorPage } from '@/pages/PostEditorPage';
import { ReelGenerationPage } from '@/pages/ReelGenerationPage';
import { SceneEditorPage } from '@/pages/SceneEditorPage';
import { PostsListPage } from '@/pages/PostsListPage';
import { ReelsListPage } from '@/pages/ReelsListPage';
import ConnectedAccountsPage from '@/pages/ConnectedAccountsPage';
import ScheduledPostsPage from '@/pages/ScheduledPostsPage';
import { CalendarPage } from '@/pages/CalendarPage';
import WritingStylesPage from '@/pages/WritingStylesPage';
import TemplatesPage from '@/pages/TemplatesPage';
import { AIAvatarPage } from '@/pages/AIAvatarPage';
import { MyAvatarsPage } from '@/pages/MyAvatarsPage';
import { AvatarFolderPage } from '@/pages/AvatarFolderPage';
import { AvatarGeneratePage } from '@/pages/AvatarGeneratePage';
import { VoiceClonePage } from '@/pages/VoiceClonePage';
import { MyVoicesPage } from '@/pages/MyVoicesPage';
import { PropertyVideoPageMemo } from '@/pages/PropertyVideoPage';
import { PropertyListPage } from '@/pages/PropertyListPage';
import { PropertyDetailPage } from '@/pages/PropertyDetailPage';
import { VideoSettingsPageMemo } from '@/pages/VideoSettingsPage';
import { PhotostudioPageNew } from '@/components/photostudio/PhotostudioPageNew';
import { PhotostudioProjectsPage } from '@/components/photostudio/PhotostudioProjectsPage';
import { PhotostudioProjectPage } from '@/components/photostudio/PhotostudioProjectPage';
import { PhotostudioElementsPage } from '@/components/photostudio/PhotostudioElementsPage';
import { AIStudioPage } from '@/pages/AIStudioPage';
import { HairstyleListPage } from '@/pages/HairstyleListPage';
import { AutomationSettingsPage } from '@/pages/AutomationSettingsPage';
import { OrganisationSettingsPage } from '@/pages/OrganisationSettingsPage';
import { AiRepliesSettingsPage } from '@/pages/AiRepliesSettingsPage';
import { PoliciesListPage } from '@/pages/insurance/PoliciesListPage';
import { RenewalListPage } from '@/pages/insurance/RenewalListPage';
import { BulkRenewalImportPage } from '@/pages/insurance/BulkRenewalImportPage';
import { CustomersListPage } from '@/pages/insurance/CustomersListPage';
import { CustomerDetailPage } from '@/pages/insurance/CustomerDetailPage';
import { PolicyFormPage } from '@/pages/insurance/PolicyFormPage';
import { InsuranceTypesListPage } from '@/pages/insurance/types/InsuranceTypesListPage';
import { CreateTypeStep1Page } from '@/pages/insurance/types/CreateTypeStep1Page';
import { TypeBuilderPage } from '@/pages/insurance/types/TypeBuilderPage';
import { MigrationPage } from '@/pages/insurance/types/MigrationPage';
import { ExtractPolicyPage } from '@/pages/insurance/types/ExtractPolicyPage';
import { ReviewPublishPage } from '@/pages/insurance/types/ReviewPublishPage';
import { ProvidersListPage } from '@/pages/insurance/ProvidersListPage';
import { ProviderFormPage } from '@/pages/insurance/ProviderFormPage';
import { LeadDetailPage } from '@/pages/LeadDetailPage';
import { DashboardPage } from '@/pages/DashboardPage';
import type { Id } from '../../../convex/_generated/dataModel'; // DEEP_IMPORT_JUSTIFIED: convex _generated is the documented exception

// Re-export messaging wrappers (extracted to stay under 300-line file limit)
export {
  TelegramPageWrapper,
  UnifiedInboxPageWrapper,
  GmailPageWrapper,
  WhatsAppPageWrapper,
} from '@/components/routing/MessagesPageWrappers';

// Re-export company + insurance org wrappers (extracted to stay under 300-line file limit)
export {
  CompanyEmployeesListPageWrapper,
  CompanyNewEmployeePageWrapper,
  CompanyEditEmployeePageWrapper,
  CompanyEmployeeDetailPageWrapper,
  CompanyPoliciesListPageWrapper,
  CompanyPolicyDetailPageWrapper,
  CompanyInvoicesListPageWrapper,
  CompanyInvoiceDetailPageWrapper,
  CompanyManagersPageWrapper,
  CompanySettingsPageWrapper,
  CompaniesListPageWrapper,
  CompanyDetailPageWrapper,
  BankAccountsPageWrapper,
  InvoicesListPageWrapper,
  InvoiceFormPageWrapper,
  InsuranceEmployeeDetailPageWrapper,
  PaymentsListPageWrapper,
  ClaimsListPageWrapper,
  InsuranceSettingsPageWrapper,
} from '@/components/routing/CompanyPageWrappers';

export function LeadsPageWrapper() {
  return (
    <AppLayoutMemo>
      <LeadsPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Kanban board page wrapper for /leads/board route, following identical pattern used for all page wrappers
export function LeadsBoardPageWrapper() {
  return (
    <AppLayoutMemo>
      <LeadsBoardPage />
    </AppLayoutMemo>
  );
}

export function PostWriterPageWrapper() {
  const { mainContent } = PostWriterPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function PostsSchedulePageWrapper() {
  const { mainContent } = PostsSchedulePage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function BusinessSettingsPageWrapper() {
  const { mainContent } = BusinessSettingsPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function CalendarPageWrapper() {
  const { mainContent } = CalendarPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function WritingStylesPageWrapper() {
  return (
    <AppLayoutMemo>
      <WritingStylesPage />
    </AppLayoutMemo>
  );
}

export function TemplatesPageWrapper() {
  return (
    <AppLayoutMemo>
      <TemplatesPage />
    </AppLayoutMemo>
  );
}

export function AIAvatarPageWrapper() {
  const { mainContent } = AIAvatarPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function MyAvatarsPageWrapper() {
  const { mainContent } = MyAvatarsPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function AvatarFolderPageWrapper() {
  const { mainContent } = AvatarFolderPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function AvatarGeneratePageWrapper() {
  const { mainContent } = AvatarGeneratePage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function VoiceClonePageWrapper() {
  const { mainContent } = VoiceClonePage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function MyVoicesPageWrapper() {
  const { mainContent } = MyVoicesPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function ConnectedAccountsPageWrapper() {
  const { mainContent } = ConnectedAccountsPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function AiModelsSettingsPageWrapper() {
  const { mainContent } = AiModelsSettingsPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function SettingsPromptsPageWrapper() {
  return (
    <AppLayoutMemo>
      <SettingsPromptsPageMemo />
    </AppLayoutMemo>
  );
}

export function ScheduledPostsPageWrapper() {
  const { mainContent } = ScheduledPostsPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function PostGenerationMultiAIPageWrapper() {
  return (
    <AppLayoutMemo>
      <PostGenerationMultiAIPage />
    </AppLayoutMemo>
  );
}

export function PostEditorPageWrapper() {
  return (
    <AppLayoutMemo>
      <PostEditorPage />
    </AppLayoutMemo>
  );
}

export function ReelGenerationPageWrapper() {
  return (
    <AppLayoutMemo>
      <ReelGenerationPage />
    </AppLayoutMemo>
  );
}

export function ReelEditorPageWrapper() {
  return <SceneEditorPage />;
}

export function PropertyVideoPageWrapper() {
  return (
    <AppLayoutMemo>
      <PropertyVideoPageMemo />
    </AppLayoutMemo>
  );
}

export function PropertyListDraftPageWrapper() {
  const { mainContent } = PropertyListPage({ filter: 'draft' });
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function PropertyListReadyPageWrapper() {
  const { mainContent } = PropertyListPage({ filter: 'ready' });
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function PropertyDetailPageWrapper() {
  const { mainContent } = PropertyDetailPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function PropertyNewPageWrapper() {
  return (
    <AppLayoutMemo>
      <PropertyVideoPageMemo />
    </AppLayoutMemo>
  );
}

export function VideoSettingsPageWrapper() {
  return (
    <AppLayoutMemo>
      <VideoSettingsPageMemo />
    </AppLayoutMemo>
  );
}

export function PostsListPageWrapper() {
  const { mainContent } = PostsListPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function ReelsListPageWrapper() {
  const { mainContent } = ReelsListPage();
  return <AppLayoutMemo>{mainContent}</AppLayoutMemo>;
}

export function PhotostudioPageWrapper() {
  return (
    <AppLayoutMemo>
      <PhotostudioPageNew />
    </AppLayoutMemo>
  );
}

export function PhotostudioProjectsPageWrapper() {
  const navigate = useNavigate();
  const handleProjectSelect = (projectId: Id<'photostudioProjects'>) => {
    navigate(`/photostudio/projects/${projectId}`);
  };
  return (
    <AppLayoutMemo>
      <PhotostudioProjectsPage onProjectSelect={handleProjectSelect} />
    </AppLayoutMemo>
  );
}

export function PhotostudioProjectPageWrapper() {
  const navigate = useNavigate();
  const { projectId } = useParams<{ projectId: string }>();
  const handleBack = () => {
    navigate('/photostudio/projects');
  };
  if (!projectId) {
    return <Navigate to="/photostudio/projects" replace />;
  }
  return (
    <AppLayoutMemo>
      <PhotostudioProjectPage
        projectId={projectId as Id<'photostudioProjects'>} // AS_JUSTIFIED: one-time Id cast from route param per CLAUDE.md exception
        onBack={handleBack}
      />
    </AppLayoutMemo>
  );
}

export function PhotostudioElementsPageWrapper() {
  return (
    <AppLayoutMemo>
      <PhotostudioElementsPage />
    </AppLayoutMemo>
  );
}

export function AIStudioPageWrapper() {
  return (
    <AppLayoutMemo>
      <AIStudioPage />
    </AppLayoutMemo>
  );
}

export function HairstyleListPageWrapper() {
  return (
    <AppLayoutMemo>
      <HairstyleListPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: AI replies settings page wrapper for /settings/ai-replies route, following identical pattern used for all settings page wrappers in this file
export function AiRepliesSettingsPageWrapper() {
  return (
    <AppLayoutMemo>
      <AiRepliesSettingsPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: New page wrapper for the Automation settings page, following the identical pattern used for all other settings wrappers in this file
export function AutomationSettingsPageWrapper() {
  return (
    <AppLayoutMemo>
      <AutomationSettingsPage />
    </AppLayoutMemo>
  );
}

export function OrganisationSettingsPageWrapper() {
  return (
    <AppLayoutMemo>
      <OrganisationSettingsPage />
    </AppLayoutMemo>
  );
}

export function PoliciesListPageWrapper() {
  return (
    <AppLayoutMemo>
      <PoliciesListPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Renewal list page wrapper for /insurance/renewal route, following identical pattern used for all insurance page wrappers in this file
export function RenewalListPageWrapper() {
  return (
    <AppLayoutMemo>
      <RenewalListPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Dedicated wrapper for /insurance/renewal-import route — distinct page and flow from RenewalListPage
export function BulkRenewalImportPageWrapper() {
  return (
    <AppLayoutMemo>
      <BulkRenewalImportPage />
    </AppLayoutMemo>
  );
}

export function PolicyFormPageWrapper() {
  return (
    <AppLayoutMemo>
      <PolicyFormPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Replaces InsuranceTypesPageWrapper — now routes /insurance/types to the new list page (Task 16)
export function InsuranceTypesListPageWrapper() {
  return (
    <AppLayoutMemo>
      <InsuranceTypesListPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: New route /insurance/types/new for type creation wizard step 1 (Task 17)
export function CreateTypeStep1PageWrapper() {
  return (
    <AppLayoutMemo>
      <CreateTypeStep1Page />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: New route /insurance/types/:typeId for the type builder editor (Task 18)
export function TypeBuilderPageWrapper() {
  return (
    <AppLayoutMemo>
      <TypeBuilderPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: New route /insurance/types/migration for orphan cleanup page (Task 25)
export function MigrationPageWrapper() {
  return (
    <AppLayoutMemo>
      <MigrationPage />
    </AppLayoutMemo>
  );
}

export function ExtractPolicyPageWrapper() {
  return (
    <AppLayoutMemo>
      <ExtractPolicyPage />
    </AppLayoutMemo>
  );
}

export function ReviewPublishPageWrapper() {
  return (
    <AppLayoutMemo>
      <ReviewPublishPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Providers list page wrapper for /insurance/providers route, following identical pattern used for all insurance page wrappers in this file
export function ProvidersListPageWrapper() {
  return (
    <AppLayoutMemo>
      <ProvidersListPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Provider form page wrapper for /insurance/providers/new and /insurance/providers/:id routes, following identical pattern used for all insurance page wrappers in this file
export function ProviderFormPageWrapper() {
  return (
    <AppLayoutMemo>
      <ProviderFormPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Lead detail page wrapper for /leads/:leadId route, following identical pattern used for all page wrappers
export function LeadDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <LeadDetailPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Customer list page wrapper for /customers route
export function CustomersListPageWrapper() {
  return (
    <AppLayoutMemo>
      <CustomersListPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Customer detail page wrapper for /customers/:customerId route
export function CustomerDetailPageWrapper() {
  return (
    <AppLayoutMemo>
      <CustomerDetailPage />
    </AppLayoutMemo>
  );
}

// NEW_FUNCTION_JUSTIFIED: Dashboard page wrapper replacing legacy /dashboard redirect
export function DashboardPageWrapper() {
  return (
    <AppLayoutMemo>
      <DashboardPage />
    </AppLayoutMemo>
  );
}

// Re-export KB wrappers (extracted to stay under 300-line file limit)
export {
  InsuranceKnowledgeBasePageWrapper,
  RealEstateKnowledgeBasePageWrapper,
} from './KnowledgeBasePageWrappers';

// Re-export voice agent wrappers (extracted to stay under 300-line file limit)
export {
  VoiceAgentsListPageWrapper,
  VoiceCallHistoryPageWrapper,
  VoiceCallDetailPageWrapper,
  VoicePhoneNumbersPageWrapper,
  VoiceSipTrunksPageWrapper,
} from './VoicePageWrappers';
